<template>
  <article
    class="pilar relative isolate flex aspect-4/5 flex-col justify-end overflow-hidden rounded-gob-lg bg-surface-deep text-white"
    tabindex="0"
    :aria-labelledby="idTitulo"
  >
    <img
      :src="imagen"
      alt=""
      class="pilar-imagen absolute inset-0 -z-10 size-full object-cover"
      :style="{ objectPosition: posicion }"
      width="1280"
      height="720"
      loading="lazy"
      decoding="async"
    />
    <div class="pilar-velo absolute inset-0 -z-10" aria-hidden="true"></div>

    <div class="p-6 sm:p-7">
      <span class="inline-flex rounded-full px-3 py-1 text-gob-0 font-semibold text-white" :class="claseTono">
        {{ nombre }}
      </span>
      <h3 :id="idTitulo" class="mt-3 text-gob-3 leading-tight font-extrabold tracking-gob-tight text-balance">
        {{ titulo }}
      </h3>
      <div class="pilar-detalle">
        <p class="min-h-0 overflow-hidden leading-relaxed text-white/90">{{ descripcion }}</p>
      </div>
    </div>
  </article>
</template>

<script>
const CLASE_TONO = {
  humano: 'bg-signal-human',
  dato: 'bg-signal-data',
  marca: 'bg-primary'
}

/**
 * HomePilarCard
 * Tarjeta de pilar: la imagen y el título tienen el protagonismo; la descripción aparece al pasar
 * el cursor o al enfocar con teclado. En pantallas táctiles (sin hover) la descripción queda visible.
 */
export default {
  name: 'HomePilarCard',
  props: {
    nombre: { type: String, required: true },
    titulo: { type: String, required: true },
    descripcion: { type: String, required: true },
    imagen: { type: String, required: true },
    tono: {
      type: String,
      default: 'marca',
      validator: (valor) => Object.keys(CLASE_TONO).includes(valor)
    },
    /** object-position del recorte vertical sobre un fotograma 16:9. */
    posicion: { type: String, default: 'center' }
  },
  computed: {
    claseTono() {
      return CLASE_TONO[this.tono]
    },
    idTitulo() {
      // NFD separa la tilde de su letra; quitar todo lo no alfanumérico deja "Emoción" en "emocion".
      const slug = this.nombre.normalize('NFD').replace(/[^a-zA-Z0-9]+/g, '').toLowerCase()
      return `pilar-${slug}`
    }
  }
}
</script>

<style scoped>
.pilar-imagen {
  transition: transform var(--duration-gob) var(--ease-gob-out);
}

.pilar-velo {
  background: linear-gradient(
    to top,
    rgb(10 12 64 / 0.94) 0%,
    rgb(10 12 64 / 0.6) 42%,
    rgb(10 12 64 / 0.05) 78%
  );
}

.pilar-detalle {
  display: grid;
  grid-template-rows: 1fr;
  margin-top: 0.75rem;
}

@media (hover: hover) and (pointer: fine) {
  .pilar-detalle {
    grid-template-rows: 0fr;
    margin-top: 0;
    opacity: 0;
    transition:
      grid-template-rows var(--duration-gob) var(--ease-gob-out),
      margin-top var(--duration-gob) var(--ease-gob-out),
      opacity var(--duration-gob) var(--ease-gob-out);
  }

  .pilar:hover .pilar-detalle,
  .pilar:focus .pilar-detalle {
    grid-template-rows: 1fr;
    margin-top: 0.75rem;
    opacity: 1;
  }

  .pilar:hover .pilar-imagen,
  .pilar:focus .pilar-imagen {
    transform: scale(1.04);
  }
}
</style>
